import { render, staticRenderFns } from "./UiTextInput.vue?vue&type=template&id=38626810&scoped=true&"
import script from "./UiTextInput.vue?vue&type=script&lang=js&"
export * from "./UiTextInput.vue?vue&type=script&lang=js&"
import style0 from "./UiTextInput.vue?vue&type=style&index=0&id=38626810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38626810",
  null
  
)

export default component.exports